module.exports = __webpack_public_path__ + "img/documento.248dbda4.png";